export const Sectors = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="path-1-inside-1_72_125" fill="white">
<rect x="3" y="3" width="12.0714" height="12.0714" rx="1"/>
</mask>
<rect x="3" y="3" width="12.0714" height="12.0714" rx="1" stroke="currentColor" stroke-width="4" mask="url(#path-1-inside-1_72_125)"/>
<mask id="path-2-inside-2_72_125" fill="white">
<rect x="3" y="16.9286" width="12.0714" height="12.0714" rx="1"/>
</mask>
<rect x="3" y="16.9286" width="12.0714" height="12.0714" rx="1" stroke="currentColor" stroke-width="4" mask="url(#path-2-inside-2_72_125)"/>
<mask id="path-3-inside-3_72_125" fill="white">
<rect x="16.9282" y="3" width="12.0714" height="12.0714" rx="1"/>
</mask>
<rect x="16.9282" y="3" width="12.0714" height="12.0714" rx="1" stroke="currentColor" stroke-width="4" mask="url(#path-3-inside-3_72_125)"/>
<mask id="path-4-inside-4_72_125" fill="white">
<rect x="16.9282" y="16.9286" width="12.0714" height="12.0714" rx="1"/>
</mask>
<rect x="16.9282" y="16.9286" width="12.0714" height="12.0714" rx="1" stroke="currentColor" stroke-width="4" mask="url(#path-4-inside-4_72_125)"/>
</svg>`;
